import React from "react";
import { useSelector } from "react-redux";
import { GetAppText } from "../../../utils";
import { Image_URL } from "../../../utils/BaseUrl";
import SvgComponent from "../SvgComponent";

export const formatPublishedDate = (dateString, language) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat(language === "_ar" ? "ar-BH" : "en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "Asia/Bahrain",
  }).format(date);
};

export const NewsCardComponent = ({ data, onClick, fluid = false, tabIndex = 0 }) => {
  const language = useSelector((state) => state.language.value);
  const isArabic = language === "_ar";
  const title = isArabic ? data?.title_ar : data?.title;
  const summary = isArabic ? data?.short_description_ar : data?.short_description;
  const publishedLabel = formatPublishedDate(data?.created_at, language);

  const openWithKeyboard = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick?.();
    }
  };

  return (
    <article
      dir={isArabic ? "rtl" : "ltr"}
      className={`${fluid ? "w-full" : "xl:w-[390px] sm:w-[360px] w-[320px]"} group flex h-full flex-col overflow-hidden rounded-xl bg-white border border-borderColor transition-[box-shadow,transform] duration-200 hover:-translate-y-1 hover:shadow-[0_12px_28px_rgba(18,52,43,0.12)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary_green`}
      role={onClick ? "link" : undefined}
      tabIndex={onClick ? tabIndex : undefined}
      aria-label={onClick ? title : undefined}
      onClick={onClick}
      onKeyDown={onClick ? openWithKeyboard : undefined}
    >
      <div className="aspect-[16/10] w-full overflow-hidden bg-[#E9ECE8]">
        <img
          alt=""
          loading="lazy"
          decoding="async"
          src={`${Image_URL}${data?.image}`}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.025]"
        />
      </div>
      <div className="flex min-h-[230px] flex-1 flex-col p-6">
        <div className="flex-1">
          <h3 className="line-clamp-2 text-F22 font-bold leading-snug text-black">
            {title}
          </h3>
          <p className="mt-3 line-clamp-3 text-F16 leading-7 text-primary">
            {summary}
          </p>
        </div>
        <div className="mt-6 flex items-center justify-between gap-4 border-t border-borderColor pt-4">
          {publishedLabel ? (
            <time dateTime={data?.created_at} className="text-F14 text-secondaryTextColor">
              {publishedLabel}
            </time>
          ) : <span />}
          <span className="inline-flex shrink-0 items-center gap-2 text-F16 font-semibold text-secondary_green group-hover:underline group-focus-visible:underline">
            {GetAppText("read_more")}
            <SvgComponent
              name={isArabic ? "ArrowLeft" : "ArrowRight"}
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
            />
          </span>
        </div>
      </div>
    </article>
  );
};
